<!-- eslint-disable max-len -->
<template>
  <div id="privacy-policy" class="">
    <h1>RUEJAI APP PRIVACY POLICY</h1>
    <p>&nbsp;</p>
    <p>Updated: 22 November 2018</p>
    <p>&nbsp;</p>
    <p>
      <span style="font-weight: 400;"
        >Ruejai App is committed to protecting your privacy. This Privacy
        Policy informs you how Ruejai App collects, uses, secures and shares
        your information. This Policy covers our privacy practices related to
        the provision of our service to you through
        https://baanruejai.scasset.com, applications on any computer device,
        through APIs, and through third parties (together, the
        &ldquo;Service&rdquo;). All of the different forms of data, content, and
        information described below are collectively referred to as
        &ldquo;information.&rdquo;</span
      >
    </p>
    <p>
      <span style="font-weight: 400;"
        >This Privacy Policy is part of, and is governed by, the terms and
        conditions set forth in our </span
      ><a href="https://baanruejai.scasset.com/terms-of-service"
        ><span style="font-weight: 400;">Terms of Service</span></a
      ><span style="font-weight: 400;"
        >. Terms not defined in this Privacy Policy shall have the meaning given
        to them in our Terms of Service.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;"
        >1. Acceptance of this Privacy Policy</span
      >
    </h3>
    <p>
      <span style="font-weight: 400;"
        >Please read the Terms of Service carefully before you use our Service.
        By accepting the Terms of Service, you agree with our privacy practices
        as described in this Privacy Policy. If you do not feel comfortable with
        any part of this Privacy Policy or our Terms of Service, you must not
        use or access our Service.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;">2. Changes to Our Privacy Policy</span>
    </h3>
    <p>
      <span style="font-weight: 400;"
        >This Privacy Policy may change from time to time. If we make a change
        to this Privacy Policy that we believe materially affects how we process
        your information or reduces your rights, we will provide you with notice
        (for example, by email). We may provide notice of changes in other
        circumstances as well. By continuing to use the Service after those
        changes become effective, you agree to be bound by the revised Privacy
        Policy.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;"
        >3. The Information We Collect and Store</span
      >
    </h3>
    <p>
      <span style="font-weight: 400;"
        >Personal information is any information that identifies your or makes
        you identifiable. Any information that is anonymized or aggregated is no
        longer personal information. We may collect and store the following
        information when running the Service:</span
      >
    </p>

    <p>
      <strong>Information You Provide.</strong
      ><span style="font-weight: 400;">
        The purpose of the Service is to help you manage applicant and candidate
        data. To do that, we collect personal information, such as your name and
        email address. You may also provide additional information such as date
        of birth, Thai Citizen ID or Passport number in the setup and ongoing
        use of the Service such as home member management and home automation
        features. We collect any information that you provide to us when you
        contact us for customer service, IT support, or for any other
        purposes.</span
      >
    </p>
    <ul>
      <li style="font-weight: 400;">
        <strong>Account Information.</strong
        ><span style="font-weight: 400;">
          When you sign up for an Ruejai App Account, we require certain
          information such as your first name, last name, email address, and
          date of birth.</span
        >
      </li>
      <li style="font-weight: 400;">
        <strong>Profile and Featured Pictures.</strong
        ><span style="font-weight: 400;">
          To use certain features of the Ruejai App Platform (such as article
          events, conversation or homecare requests), we may ask you to provide
          additional information, which may include your address, phone number,
          and a profile picture. You may provide pictures that considered as
          non-harmed to your identity and your safety to the Service for
          additional information such as cracks on the wall picture to help us
          investigate and take care of your problems quickly.</span
        >
      </li>
      <li style="font-weight: 400;">
        <strong>Identity Verification Information.</strong
        ><span style="font-weight: 400;">
          To help create and maintain a trusted environment, we may collect
          identity verification information (such as passport, Thai national ID
          card, as permitted by applicable laws) or other authentication
          information.</span
        >
        <ul>
          <li>
            <h4>When you&rsquo;ll be asked for an ID</h4>
            <p>
              <span style="font-weight: 400;"
                >We&rsquo;ll ask for an ID to help us confirm you&rsquo;re
                really you once when you first logging in to the Service and
                your Ownership of a real estate unit has not been
                verified.</span
              >
            </p>
            <p>
              <span style="font-weight: 400;"
                >But whatever the reason, your ID will never be shared with a
                host or anyone else who uses Ruejai App.</span
              >
            </p>

            <p>
              <span style="font-weight: 400;"
                >You can skip providing an ID or provide it later when you are
                ready to verify your Ownership of a real estate unit.</span
              >
            </p>
          </li>
          <li>
            <h4>Types of ID</h4>
            <p>
              <span style="font-weight: 400;"
                >Depending on your location and what country you&rsquo;re from,
                you may be able to add one of the following types of ID:</span
              >
            </p>
            <ul>
              <li style="font-weight: 400;">
                <span style="font-weight: 400;">Passport Number</span>
              </li>
              <li style="font-weight: 400;">
                <span style="font-weight: 400;"
                  >Thai National identity card</span
                >
              </li>
            </ul>
            <p>
              <span style="font-weight: 400;"
                >It needs to match the records of the real estate unit
                information we integrated with to verify your real
                identity.</span
              >
            </p>

            <p>
              <span style="font-weight: 400;"
                >We do not share your ID to any Third-Party Services. We only
                matching your identity with our trusted partner and give your
                rights to have the appropriate Owner features.</span
              >
            </p>
          </li>
          <li>
            <h4>Privacy</h4>
            <p>
              <span style="font-weight: 400;"
                >We take privacy seriously. The information you provide during
                the process of adding your ID is governed by our Privacy Policy
                and sent to us and our trusted partners using SSL.</span
              >
            </p>
          </li>
        </ul>
      </li>
    </ul>

    <p>
      <strong>Log Data.</strong
      ><span style="font-weight: 400;">
        When you use the Service, we automatically record information from your
        device, its software, and your activity using the Services (&ldquo;Log
        Data&rdquo;). This may include the device&rsquo;s Internet Protocol
        (&ldquo;IP&rdquo;) address, browser type, identification numbers
        associated with your devices, date and time stamps associated with
        transactions, system configuration information, metadata concerning your
        Files, and other interactions with the Service.</span
      >
    </p>

    <p>
      <strong>Geo-Location Information.</strong
      ><span style="font-weight: 400;">
        Some photos and videos you place in Ruejai App may contain recorded
        location information. If you do not wish to share files embedded with
        your geo-location information with us, please do not upload them. If you
        do not want to store location data in your photos or videos, please
        consult the documentation for your camera to turn off that feature.
        Also, some of the information we collect from a device, for example IP
        address, can sometimes be used to approximate a device&rsquo;s
        location.</span
      >
    </p>

    <p>
      <strong>Cookies.</strong
      ><span style="font-weight: 400;">
        We use &ldquo;cookies&rdquo; to collect information and improve our
        Services. A cookie is a small data file that we transfer to your device.
        We may use &ldquo;persistent cookies&rdquo; to save your registration ID
        and login password for future logins to the Service. We may use
        &ldquo;session ID cookies&rdquo; to enable certain features of the
        Service, to better understand how you interact with the Service and to
        monitor aggregate usage and web traffic routing on the Service. For more
        information on how we use Cookies and similar technologies.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;"
        >4. Third Party Sources of Information</span
      >
    </h3>
    <p>
      <span style="font-weight: 400;"
        >We collect information about you from the following third-party
        sources:</span
      >
    </p>

    <p>
      <strong>Third-Party Services.</strong
      ><span style="font-weight: 400;">
        You may ask us to collect information about you or others from
        Third-Party Services. For example, you can share your social networking
        information with us if you give us access via a social network
        connection service (for example, Facebook).</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;">5. How We Use Personal Information</span>
    </h3>
    <p>
      <span style="font-weight: 400;"
        >Your personal information may be used for the following purposes:</span
      >
    </p>

    <p>
      <strong>To provide our Services to you.</strong
      ><span style="font-weight: 400;">
        We process your personal information to provide you with the Service you
        request. We share this information with Third-Party Services upon your
        request, or our service providers or partners to the extent necessary to
        provide you with the Services. We cannot provide you with Services
        without processing your personal information.</span
      >
    </p>

    <p>
      <strong>To contact you about the Service.</strong
      ><span style="font-weight: 400;">
        When you sign up for our Service, we will send you administrative or
        account-related information to you to keep you updated about our
        Services, inform you of relevant security issues or updates, or provide
        other transaction-related information to you.</span
      >
    </p>

    <p>
      <strong>To conduct research and development.</strong
      ><span style="font-weight: 400;">
        To continue to provide you with our innovative Services, we information
        about the way you use and interact with our Services for research and
        development purposes. Research and development help us improve our
        Services, and build new Services and customized features or Services. We
        take additional security measures when processing your personal
        information for such purposes, by de-identifying or pseudonymizing your
        information, limiting access to personnel that may conduct research and
        development, and applying other technical, physical, and administrative
        security measures. Without processing your personal information for such
        purposes, we cannot guarantee your continued enjoyment of part or all of
        our Services.</span
      >
    </p>

    <p>
      <span style="font-weight: 400;"
        >If, in the future, we use your personal information in any way that is
        not described in this Privacy Policy, we will disclose this to you. At
        that time, you can choose not to allow us to use your personal
        information for any purpose that is incompatible with the purposes for
        which we originally collected it or subsequently obtained your consent.
        If you choose to limit the ways we can use your personal information,
        some or all of the Services may not be available to you.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;"
        >6. Information Sharing and Disclosure</span
      >
    </h3>
    <p>
      <span style="font-weight: 400;"
        >We share and disclose your personal information as described
        below.</span
      >
    </p>

    <p>
      <strong>Service Providers, Business Partners and Others.</strong
      ><span style="font-weight: 400;">
        We use certain trusted third-party companies and individuals to help us
        provide, analyze, and improve the Service (including but not limited to
        data storage, maintenance services, database management, web analytics,
        security, and improvement of the Service&rsquo;s features). For example,
        we use Google Cloud &nbsp;Storage service to store some of your
        information (for more information on Google Cloud Storage security see
        https://cloud.google.com/storage/docs/gsutil/addlhelp/SecurityandPrivacyConsiderations).
        These third parties may have access to your information only for
        purposes of performing these tasks on our behalf and under obligations
        similar to those in this Privacy Policy or our agreements with
        you.</span
      >
    </p>

    <p>
      <strong>Third-Party Services.</strong
      ><span style="font-weight: 400;">
        Ruejai App also allows for the optional integration of other
        Third-Party Services with your Ruejai App account. We are not
        responsible for what these Third Parties and their Services do with your
        personal information, and your use of them will be subject to their
        respective terms of service and privacy policies.</span
      >
    </p>

    <p>
      <strong>Non-private or Non-personal Information.</strong
      ><span style="font-weight: 400;">
        We may disclose your non-private, aggregated, or otherwise non-personal
        information, such as usage statistics of our Service, and use this
        information for both commercial and non-commercial purposes.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;"
        >7. Accessing, Changing or Deleting Your Information</span
      >
    </h3>
    <p>
      <span style="font-weight: 400;"
        >If you are a registered user, you may review, or update the personal
        information provided in your registration or account profile. If your
        personal information changes, or if you no longer desire our service,
        you may send a request to delete it by contact info@scasset.com. In some
        cases we may retain copies of your information if required by law. For
        questions about your personal information on our Service, please contact
        info@scasset.com. We will use responsible efforts to respond to your
        inquiry as soon as practicable. When updating your personal information,
        we may ask you to verify your identity before we can act on your
        requests.</span
      >
    </p>
    <h3><span style="font-weight: 400;">8. Data Retention</span></h3>
    <p>
      <span style="font-weight: 400;"
        >If you wish to cancel your account or request that we no longer use
        your personal information to provide you the Service, you may delete
        your account by sending a request to delete your account to
        info@scasset.com. We may retain and use your information as necessary to
        comply with our legal obligations, resolve disputes, or enforce our
        agreements. Consistent with these requirements, we will try to delete
        your information quickly upon request. Please note, however, that there
        might be latency in deleting information from our servers and backed-up
        versions might exist after deletion. In addition, we do not delete from
        our servers files any information that you have in common with other
        users.While retention requirements can vary by country, we generally
        apply the retention periods noted below. Please contact us if you have
        any questions about our retention periods.</span
      >
    </p>
    <h3><span style="font-weight: 400;">9. Security</span></h3>
    <p>
      <span style="font-weight: 400;"
        >The security of your information is important to us. We follow
        generally accepted standards to protect the information submitted to us,
        both during transmission and once we receive it. No method of electronic
        transmission or storage is 100% secure, however. Therefore, we cannot
        guarantee its absolute security. If you have any questions about
        security on our website, you can contact us at info@scasset.com.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;">10. Our Policy Toward Children</span>
    </h3>
    <p>
      <span style="font-weight: 400;"
        >Our Services are not directed to persons under 13. We do not knowingly
        collect personal information from children under 13. Any individuals
        under the age of 13 must have consent to use the Services from their
        parent or guardian. If a parent or guardian becomes aware that his or
        her child has provided us with personal information without their
        consent, he or she should contact us at info@scasset.com. If we become
        aware that a child under 13 has provided us with personal information,
        we will take steps to delete such information from our files.</span
      >
    </p>
    <h3>
      <span style="font-weight: 400;"
        >11. Transfer of Personal Information</span
      >
    </h3>
    <p>
      <span style="font-weight: 400;"
        >If you access or use our Service or provide your information to us,
        your personal information may be transferred to, processed and
        maintained on servers or databases located outside of the country or
        jurisdiction where you are located. Such countries or jurisdictions may
        have data protection laws that are less protective than the laws of the
        jurisdiction in which you reside. If you do not want your information
        transferred to or processed or maintained outside of the country or
        jurisdiction where you are located, you should not use the
        Services.</span
      >
    </p>
    <h3><span style="font-weight: 400;">12. Contacting Us</span></h3>
    <p>
      <span style="font-weight: 400;"
        >If you have any questions about this Privacy Policy, please contact us
        at info@scasset.com.</span
      >
    </p>
  </div>
</template>

<script>
export default {
  name: 'PolicyPrivacyPage',
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
#privacy-policy {
  padding: 5%;
  height: 100%;
  overflow-y: scroll;

  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: left;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  h4 {
    font-size: 1rem;
    font-weight: bold;
  }

  p {
    margin-top: 10px;
  }

  ul,
  ol {
    color: #000;
    margin-top: 8px;
  }

  li {
    text-align: left;

    p {
      line-height: 1.6rem;
      color: inherit;
    }
  }
}

@media screen and (max-width: 420px) {
  h1 {
    font-size: 2rem;
  }
}
</style>
